module.exports = __webpack_public_path__ + "static/img/noAccess.1310a16e.svg";